<template>
  <div :class="$style.container">
    <div :class="$style.date">Дата</div>
    <div :class="$style.content">
      <div :class="$style.column">Название проекта</div>
      <div :class="$style.column">Тип проекта</div>
      <div :class="$style.column">Статус проекта</div>
      <div :class="$style.column">Канал привлечения</div>
      <div :class="$style.column">Тип оплаты</div>
      <div :class="$style.column">Квалифик. лида</div>
      <div :class="$style.column">Оценка время / цена</div>
    </div>
    <div :class="$style.edit">
      <img src="/icons/edit.svg" alt="" />
    </div>
  </div>
</template>

<style lang="scss" module>
.container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.5rem;
  background-color: $bg-primary;
  padding: 1rem 1.5rem;
  border-top: 1px solid $bg-separator;
  border-bottom: 1px solid $bg-separator;
  @include Subtitle;
  .date {
    flex: 0 0 5rem;
  }
  .content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex: 1 1 auto;
    .column {
      min-width: 9.5rem;
      width: 100%;
      &:last-child {
        min-width: none;
        width: 9.5rem;
      }
    }
  }

  .edit {
    width: 1.5rem;
  }
}
</style>
